/**
 * @generated SignedSource<<32072c4b8955a79801032d3bd9d73be7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSchedulerAttendeeInput_personsByCalendarIdsErrorable$data = {
  readonly __typename: "PersonList";
  readonly list: ReadonlyArray<{
    readonly id: string;
    readonly emails: ReadonlyArray<string>;
    readonly primaryEmail: string;
    readonly primaryCalendar: any;
    readonly profile: {
      readonly givenName: string | null;
      readonly familyName: string | null;
      readonly externalImageUrl: string | null;
    } | null;
    readonly isYou: boolean;
    readonly isOutsideOrg: boolean;
  }>;
  readonly " $fragmentType": "EventSchedulerAttendeeInput_personsByCalendarIdsErrorable";
} | {
  readonly __typename: "GraphEntityError";
  readonly message: string | null;
  readonly " $fragmentType": "EventSchedulerAttendeeInput_personsByCalendarIdsErrorable";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "EventSchedulerAttendeeInput_personsByCalendarIdsErrorable";
};
export type EventSchedulerAttendeeInput_personsByCalendarIdsErrorable$key = {
  readonly " $data"?: EventSchedulerAttendeeInput_personsByCalendarIdsErrorable$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerAttendeeInput_personsByCalendarIdsErrorable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSchedulerAttendeeInput_personsByCalendarIdsErrorable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "list",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emails",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryCalendar",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "givenName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "familyName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalImageUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isYou",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isOutsideOrg",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PersonList",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "type": "GraphEntityError",
      "abstractKey": null
    }
  ],
  "type": "PersonListErrorable",
  "abstractKey": "__isPersonListErrorable"
};

(node as any).hash = "100a1d2e4a27bd7bb1456c6e6a1ed5f9";

export default node;
